export const ConnectOptionType = {
  LIVE_CHAT: 'LIVE_CHAT',
  /** Twilio agent voice call (connect wizard). */
  VOICE_CALL: 'VOICE_CALL',
  /** Landing Voice AI (@pleased-npm/voice-ai-client) — not Twilio. */
  VOICE_AI: 'VOICE_AI',
  OPEN_REQUEST: 'OPEN_REQUEST',
  FOLLOW_UP: 'FOLLOW_UP',
  CANCEL: 'CANCEL',
} as const;

export type ConnectOptionKind = (typeof ConnectOptionType)[keyof typeof ConnectOptionType];
